import React, { useState } from "react"
import Button from "@material-ui/core/Button"
import CssBaseline from "@material-ui/core/CssBaseline"
import TextField from "@material-ui/core/TextField"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import { makeStyles } from "@material-ui/core/styles"
import Container from "@material-ui/core/Container"
import InputAdornment from "@material-ui/core/InputAdornment"
import AssignmentIcon from "@material-ui/icons/Assignment"
import { setReportLink } from "@/apisSuperAdmin"

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    centerText: {
        textAlign: "center",
    },
    inputField: {
        marginTop: "10px",
        marginBottom: "10px",
    },
}))

export default function ReportReady() {
    const [projectId, setProjectId] = useState("")
    const [projectReportLink, setProjectReportLink] = useState("")
    const [errorMsg, setErrorMsg] = useState({})
    const [submitStatus, setSubmitStatus] = useState({
        status: undefined,
        errMsg: "",
    })

    const classes = useStyles()

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!projectId)
            setErrorMsg((prevErrorMsg) => ({
                ...prevErrorMsg,
                projectId: "Please input projectId",
            }))
        if (!projectReportLink)
            setErrorMsg((prevErrorMsg) => ({
                ...prevErrorMsg,
                projectReportLink: "Please input projectReportLink",
            }))
        if (errorMsg.projectId === "" && errorMsg.projectReportLink === "") {
            // email send
            try {
                await setReportLink({
                    projectId,
                    projectReportLink,
                })
                setSubmitStatus({
                    status: true,
                    errMsg: "",
                })
            } catch (error) {
                setSubmitStatus({
                    status: false,
                    errMsg: error.data.message ?? "wrong",
                })
            }
        }
    }

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <form className={classes.root} noValidate autoComplete="off">
                <div className={classes.paper}>
                    <Typography component="h1" variant="h4">
                        Set report link
                    </Typography>
                    <Grid container spacing={1} alignItems="flex-end">
                        <Grid item xs={12}>
                            <TextField
                                className={classes.inputField}
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                id="projectId"
                                label="ProjectId"
                                name="projectId"
                                error={!!errorMsg.projectId}
                                helperText={errorMsg.projectId}
                                onChange={(e) => {
                                    setProjectId(e.target.value)
                                    setErrorMsg((prevErrorMsg) => ({
                                        ...prevErrorMsg,
                                        projectId: "",
                                    }))
                                }}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <AssignmentIcon />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                className={classes.inputField}
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                id="projectReportLink"
                                label="projectReportLink"
                                name="projectReportLink"
                                error={!!errorMsg.projectReportLink}
                                helperText={errorMsg.projectReportLink}
                                onChange={(e) => {
                                    setProjectReportLink(e.target.value)
                                    setErrorMsg((prevErrorMsg) => ({
                                        ...prevErrorMsg,
                                        projectReportLink: "",
                                    }))
                                }}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <AssignmentIcon />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>
                    </Grid>
                    <Button type="submit" fullWidth variant="contained" color="primary" className={classes.submit} onClick={handleSubmit}>
                        Set
                    </Button>
                </div>
            </form>
            <div>{submitStatus.status && <p>Submitted</p>}</div>
            <div>
                {submitStatus.status === false && (
                    <>
                        <p>Submit failed</p>
                        <p>{submitStatus.errMsg}</p>
                    </>
                )}
            </div>
        </Container>
    )
}
